import type {z} from "zod";

import {ListMaterialFunctionsQueryParams} from "@project/sdk/engineering/zod";

export const listMaterialFunctionsSearchSchema = ListMaterialFunctionsQueryParams.extend({
  page: ListMaterialFunctionsQueryParams.shape.page.catch(1).default(1),
  perPage: ListMaterialFunctionsQueryParams.shape.perPage.catch(20).default(20),
  q: ListMaterialFunctionsQueryParams.shape.q.catch(undefined),
  state: ListMaterialFunctionsQueryParams.shape.state.catch("ACTIVE"),
  sortKey: ListMaterialFunctionsQueryParams.shape.sortKey.catch("materialFunctionId"),
  sortDir: ListMaterialFunctionsQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListMaterialFunctionsSearchInput = z.input<typeof listMaterialFunctionsSearchSchema>;
export type ListMaterialFunctionsSearch = z.output<typeof listMaterialFunctionsSearchSchema>;
